<template>
  <div>
    <h4 class="mb-2">Общая статистика</h4>
    <v-row dense>
      <v-col md="3" sm="6" cols="12">
        <v-card>
          <v-card-text class="text-center">
            <p style="font-size: 12px;" class="font-weight-medium mb-7">Общая сумма рассрочек</p>
            <p style="font-size: 35px;" class="secondary--text">{{ creditData.amount |numberToString }}</p>
            <p style="font-size: 12px;" class="secondary--text">Количество расрочек: {{ creditData.credit_count |numberToString }}</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="3" sm="6" cols="12">
        <v-card>
          <v-card-text class="text-center">
            <p style="font-size: 12px;" class="font-weight-medium mb-7">Общая сумма первоночальной оплаты</p>
            <p style="font-size: 35px;" class="secondary--text">{{ creditData.initial_payment |numberToString }}</p>
            <p style="font-size: 12px;" class="secondary--text">Количество расрочек: {{ creditData.initialCount |numberToString }}</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="3" sm="6" cols="12">
        <v-card>
          <v-card-text class="text-center">
            <p style="font-size: 12px;" class="font-weight-medium mb-7">Прибыль на будущих периодов</p>
            <p style="font-size: 35px;" class="secondary--text">{{ creditData.percentData.percent |numberToString }}</p>
            <p style="font-size: 12px;" class="secondary--text">Основная сумма: {{ creditData.percentData.main |numberToString }}</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="3" sm="6" cols="12">
        <v-card>
          <v-card-text class="text-center">
            <p style="font-size: 12px;" class="font-weight-medium mb-7">Общая задолженность</p>
            <p style="font-size: 35px;" class="error--text">{{ creditData.debtAmount.all|numberToString }}</p>
            <p style="font-size: 12px;" class="secondary--text">Кол-во: {{ creditData.debtCount |numberToString }} | Основная: {{ creditData.debtAmount.main_debt |numberToString }} | Процент: {{ creditData.debtAmount.percent_debt |numberToString }} </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div class="mt-4">
      <v-row>
        <v-col md="8" cols="12" v-if="creditStatisticsLineData.labels.length">
          <v-card style="height: 100%">
            <div class="px-6 py-4">
              <h4>График кредитов</h4>
            </div>
            <v-card-text>
              <line-chart
                :chart-data="creditStatisticsLineData"
                :options="lineChartOptions"
              ></line-chart>
              <div class="d-flex justify-center flex-md-row flex-column ma-n1">
                <div class="pa-1"
                     v-for="(item, index) in allStatistics"
                     :key="`statistics-${index}`">
                  <div class="pb-2 text-center d-flex flex-column justify-center"
                       style="padding-left: 2px; padding-right: 2px;" height="100%">
                    <p style="font-size: 12px;" class="font-weight-bold mb-1">{{ item.name }}</p>
                    <span class="title">{{ item.count|numberToString }}</span>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col md="4" cols="12" v-if="barChartData.labels.length">
          <v-card style="height: 100%">
            <div class="px-6 py-4">
              <h4>Выплаты</h4>
            </div>
            <v-card-text>
              <bar-chart
                :chart-data="barChartData"
                :options="barChartOptions"
              >
              </bar-chart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col md="4" cols="12" v-if="debtsList.length">
          <v-card style="height: 100%">
            <div class="px-6 pt-4">
              <h4>Просрочки</h4>
            </div>
            <v-card-text>
              <v-simple-table>
                <thead>
                <tr>
                  <td>Срок</td>
                  <td>Кол-во</td>
                  <td>Сумма долга(сум)</td>
                </tr>
                </thead>
                <tbody>
                <tr
                  :key="`debts-list-item-${index}`"
                  v-for="(item, index) in debtsList">
                  <td>{{ item.name }}</td>
                  <td>{{ item.count |numberToString }}</td>
                  <td>{{ item.sum |numberToString }}</td>
                </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col md="8" cols="12" v-if="debtsList.length">
          <dashboard-income-table/>
        </v-col>

      </v-row>
    </div>
  </div>
</template>


<script>

import {getMonthByNumber} from "@/utils/pureFunctions";


import LineChart from "@/components/chart/LineChart";
import BarChart from "@/components/chart/BarChart";
import ScatterChart from "@/components/chart/ScatterChart";
import {moneyToString} from 'short-money'
import {CREDIT_STATUS_INDEX} from "@/utils/constants";
import DashboardIncomeTable from "@/components/dashboard/IncomeTable";

export default {
  components: {DashboardIncomeTable, ScatterChart, BarChart, LineChart},
  data() {
    return {
      expiredCredits: 0,
      inProcessCredits: 0,
      inProcessCreditsTotal: 0,
      debtCredits: 0,
      debtsList: [],
      barChartData: {
        labels: [],
        datasets: []
      },
      allStatistics: [],
      lineChartOptions: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                padding: 15,
                stepSize: 1,
                min: 0,
                callback(value) {
                  return moneyToString(value)
                }
              },
              gridLines: {
                display: false
              }
            }
          ]
        }
      },
      barChartOptions: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                callback(value) {
                  return moneyToString(value)
                }
              },
              gridLines: {
                display: false
              }
            }
          ]
        }
      },
      creditStatisticsLineData: {
        labels: [1],
        datasets: []
      },
      creditData: {},
    }
  },
  methods: {
    async getStatisticsChart() {
      try {
        const {data: {data: {chart, statistic}}} = await this.$http.get('admin/statistics')
        const labels = []
        const cancelled = {
          label: CREDIT_STATUS_INDEX.cancelled.text,
          borderColor: '#e05d5d',
          pointBackgroundColor: '#e05d5d',
          fill: false,
          data: []
        }
        const confirmed = {
          label: CREDIT_STATUS_INDEX.activated.text,
          borderColor: '#1bb01d',
          pointBackgroundColor: '#1bb01d',
          fill: false,
          data: []
        }
        const created = {
          label: CREDIT_STATUS_INDEX.created.text,
          borderColor: '#56b5e0',
          pointBackgroundColor: '#56b5e0',
          fill: false,
          data: []
        }
        const done = {
          label: CREDIT_STATUS_INDEX.done.text,
          borderColor: '#56e0c4',
          pointBackgroundColor: '#56e0c4',
          fill: false,
          data: []
        }
        const datasets = [cancelled, confirmed, done, created]
        chart.forEach(item => {
          labels.push(item.date)
          cancelled.data.push(item.status_cancelled)
          confirmed.data.push(item.status_confirmed)
          created.data.push(item.status_created)
          done.data.push(item.status_done)
        })

        this.creditStatisticsLineData = {labels, datasets}
        this.allStatistics = statistic

      } catch (e) {
        this.$setResponseError({error: e})
      }
    },
    setExpiredCredits(data) {
      this.expiredCredits = data
    },
    setInProcessCreditTotal(data) {
      this.inProcessCreditsTotal = data
    },
    setInProcessCredits(data) {
      this.inProcessCredits = data
    },
    setDebtCredits(data) {
      this.debtCredits = data
    },
    async getPaymentChart() {
      try {
        const {data: {data}} = await this.$http.get('admin/statistics/chart')
        const months = {}
        data.cash.forEach(item => {
          if (!months[item.date_part]) {
            months[item.date_part] = {
              month: getMonthByNumber(item.date_part),
              card: 0,
              online: 0,
              cash: parseInt(item.amount)
            }
          } else {
            months[item.date_part].cash += parseInt(item.amount)
          }
        })
        data.card.forEach(item => {
          if (!months[item.date_part]) {
            months[item.date_part] = {
              month: getMonthByNumber(item.date_part),
              card: parseInt(item.amount),
              online: 0,
              cash: 0
            }
          } else {
            months[item.date_part].card += parseInt(item.amount)
          }
        })
        data.online.forEach(item => {
          if (!months[item.date_part]) {
            months[item.date_part] = {
              month: getMonthByNumber(item.date_part),
              card: 0,
              online: parseInt(item.amount),
              cash: 0
            }
          } else {
            months[item.date_part].online += parseInt(item.amount)
          }
        })
        const labels = []
        const card = {
          label: 'Карта',
          backgroundColor: 'rgba(29,154,120,0.72)',
          data: []
        }
        const cash = {
          label: 'Наличные',
          data: [],
          backgroundColor: 'rgba(29,110,173,0.75)',
        }
        const online = {
          label: 'Онлайн',
          data: [],
          backgroundColor: 'rgba(241,157,25,0.71)',
        }
        Object.entries(months).forEach(([_, value]) => {
          labels.push(value.month)
          card.data.push(value.card)
          cash.data.push(value.cash)
          online.data.push(value.online)
        })

        this.barChartData = {
          labels,
          datasets: [card, cash, online]
        }


      } catch (e) {
        this.$setResponseError({error: e})
      }
    },
    setDebtList(list) {
      this.debtsList = list
    },
    async getDashboardData() {
      try {
        const {data} = await this.$http.get('admin/dashboard')
        this.creditData = data.data.creditData;
        this.debtsList = data.data.debtsTable
        console.log(this.debtsList);
        // this.setDebtList(deptList)
        // this.setExpiredCredits(expiredCredits)
        // this.setInProcessCredits(inProcessCredits)
        // this.setInProcessCreditTotal(inProcessCreditTotal)
        // this.setDebtCredits(debtCredits)
      } catch (e) {
        this.$setResponseError({error: e})
      }
    },
  },
  async mounted() {
    this.$showLoading()
    await this.getStatisticsChart()
    await this.getPaymentChart()
    await this.getDashboardData()
    this.$clearLoading()
  }
}
</script>
